export default __webpack_public_path__ + "static/media/h-empresa.7806b118.webp";